<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2022-02-24 00:51:37
 * @LastEditTime: 2022-02-24 01:14:44
 * @LastEditors: chenguobiao
-->
<template>
  <!-- 返回 -->
  <div class="back" @click="handleBack">
    <template v-if="backHome">
      <!-- <img src="@/render/assets/images/icon_home.png" />返回首页 -->
      <img src="@/render/assets/images/icon_home.png" />
    </template>
    <template v-else>
      <!-- <img src="@/render/assets/images/personal/icon_back.png" />返回 -->
      <img src="@/render/assets/images/icon_back.png" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    backHome: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleBack() {
      if (this.backHome) {
        this.$router.replace('/home')
      } else {
        this.$router.back()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.back {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  transform: translate(100%, val(-12));
  margin-right: val(-30);
  img {
    width: val(149);
  }
}
</style>
